import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { FunctionsState } from './types';
import { RootState } from '../types';
import { Functions } from '@/Classes/Entities';

// 一番最初にレンダリングされたときの状態を設定
export const state: FunctionsState = {
    functionMap: new Functions(),
    status: false,
};

const namespaced: boolean = true;

export const functions: Module<FunctionsState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};

